import axios from "axios";
import { useCallback } from "react";

export const useApi = () => {
  const baseUrl = process.env.REACT_APP_API_BASE_URL ?? "";
  return {
    fetchEvents: useCallback(
      async (
        page = 1,
        eventType = "",
        latitude = "",
        longitude = "",
        locationType = "",
        locationId = "",
        timeStamp = "",
        weekStartDate?: string,
        weekEndDate?: string
      ) => {
        const apiParams: any = {
          events_page: page,
          event_type: eventType,
          latitude,
          longitude,
          location_type: locationType,
          location_id: locationId,
        };

        if (timeStamp) {
          apiParams.time_stamp = timeStamp;
        }
        if (weekStartDate) {
          apiParams.week_start_date = weekStartDate;
        }
        if (weekEndDate) {
          apiParams.week_end_date = weekEndDate;
        }

        const { data } = await axios.get(
          `${baseUrl}/wp-content/plugins/tror-event-search/tror-event-search--es-proxy.php`,
          {
            params: apiParams,
          }
        );
        return {
          hits: data?.hits?.hits,
          total: data?.hits?.total?.value,
          total_pages: data?.total_pages,
        };
      },
      [baseUrl]
    ),
    fetchEventDetails: useCallback(
      async (eventIds: number[] | string[]) => {
        const { data } = await axios.get(
          `${baseUrl}/wp-content/plugins/tror-event-search/tror-event-search--details.php`,
          {
            params: {
              post_id: eventIds.join("+"),
            },
          }
        );
        return {
          results: data?.matching_posts ?? [],
        };
      },
      [baseUrl]
    ),
    fetchEventTypes: useCallback(async () => {
      const { data } = await axios.get(
        `${baseUrl}/wp-content/plugins/tror-event-search/tror-event-search--event-categories.php`
      );
      return data;
    }, [baseUrl]),
    fetchWhereAutocomplete: useCallback(
      async (search: string) => {
        const { data } = await axios.get(
          `${baseUrl}/wp/wp-admin/admin-ajax.php`,
          {
            params: {
              action: "where_autocomplete",
              s: search,
            },
          }
        );
        return data;
      },
      [baseUrl]
    ),
    fetchLocationBySlug: useCallback(
      async (slug: string) => {
        const { data } = await axios.get(
          `${baseUrl}/wp/wp-admin/admin-ajax.php`,
          {
            params: {
              action: "where_autocomplete",
              s: slug,
            },
          }
        );
        // Find exact match by slug (post_name)
        const exactMatch = Array.isArray(data) 
          ? data.find((item: any) => item.id === slug)
          : undefined;
        return exactMatch ? {
          value: exactMatch.id,
          label: exactMatch.text,
          latitude: exactMatch.location?.latitude,
          longitude: exactMatch.location?.longitude,
          locationType: exactMatch.type,
          locationId: exactMatch.locationId,
        } : undefined;
      },
      [baseUrl]
    ),
  };
};
